const passkey_verification = {
    title: 'Passkey-Verifizierung',
    description: 'Verwenden Sie Ihren Passkey, um Ihre Identität zu verifizieren und diese Aktion fortzusetzen.',
    verify: 'Mit Passkey verifizieren',
    error_failed: 'Passkey-Verifizierung fehlgeschlagen. Bitte erneut versuchen.',
    error_cancelled: 'Die Verifizierung wurde abgebrochen.',
};
export default Object.freeze(passkey_verification);
